/* eslint radix: ["off"] */

import React, { Component } from 'react';
import './RpmTabChart.css';
import RpmScatterChart from './RpmScatterChart';

import moment from 'moment';
import { inject } from 'mobx-react';
import AirButton from '../../../../../../../common/components/AirButton';
import { ArrowLeftIcon, ArrowRightIcon } from '../../../../../../../common/icons';

@inject('commonStore', 'translationsStore')
export default class RpmTabChart extends Component {
  buildTooltip = (headerDOMElement, contentDOMElement, payload) => {
    const { translationsStore, commonStore } = this.props;

    headerDOMElement.innerHTML =
      `<div>` +
      ` <div>${payload.y.toLocaleString(commonStore.momentLocale)} ${translationsStore.translate('rpm')}</div>` +
      `  <div>` +
      `   <div>${moment(parseInt(payload.x)).format(commonStore.longDateFormat.L)}</div>` +
      `   <div>${moment(parseInt(payload.x)).format(commonStore.longDateFormat.LT)}</div>` +
      `  </div>` +
      ` </div>` +
      `</div>`;

    contentDOMElement.innerHTML =
      `<div>` +
      ` <div><span>${translationsStore.translate('address')}</span>: <span>${payload.address}</span></div>` +
      ` <div><span>${translationsStore.translate('duration')}</span>: <span>${moment()
        .startOf('day')
        .seconds(payload.z)
        .format('H:mm:ss')}</span></div>` +
      ` <div><span>${translationsStore.translate('distance')}</span>: <span>${payload.distance} km</span></div>` +
      `</div>`;
  };

  prev = () => {
    const { startDate, endDate, prevWeekDisabled } = this.props;
    !prevWeekDisabled &&
      this.props.onChange(
        moment(startDate)
          .subtract(7, 'days')
          .toDate(),
        endDate
      );
  };

  next = () => {
    const { startDate, endDate, nextWeekDisabled } = this.props;
    !nextWeekDisabled &&
      this.props.onChange(
        moment(startDate)
          .add(7, 'days')
          .toDate(),
        endDate
      );
  };

  render() {
    const { startDate, endDate, commonStore, data, translationsStore } = this.props;

    let xAxisTicks = [];
    for (let s = moment(startDate); s.isSameOrBefore(moment(endDate).add(1, 'day')); s.add(1, 'day')) {
      xAxisTicks.push(parseInt(s.format('x')));
    }

    return (
      <div className="RpmTabChart">
        <div className="title">OVER RPM</div>
        <RpmScatterChart
          dateFormat={commonStore.longDateFormat.L}
          xAxisTicks={xAxisTicks}
          width={827}
          height={342}
          data={data || []}
          mapFn={d => {
            const duration = d.duration <= 10 ? 50 : d.duration <= 20 ? 250 : 750;
            return { x: moment(d.startDateTime).format('x'), y: d.value, z: duration, address: d.address, distance: parseInt(d.distance) / 1000 };
          }}
          buildTooltip={this.buildTooltip}
        />
        <div className="arrows">
          <div className={`${this.props.prevWeekDisabled ? 'disabled' : ''}`} onClick={this.prev}>
            <AirButton bgcolor="transparent" icon={<ArrowLeftIcon />} />
            <div>{translationsStore.translate('previous 7 days')}</div>
          </div>
          <div className={`${this.props.nextWeekDisabled ? 'disabled' : ''}`} onClick={this.next}>
            <div>{translationsStore.translate('next 7 days')}</div>
            <AirButton bgcolor="transparent" icon={<ArrowRightIcon />} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/RpmTabChart/RpmTabChart.js